export default {
  Small: 0,
  Medium: 1,
  Large: 2,
  XLarge: 3,
  Carafe: 4,
};
